import { render, staticRenderFns } from "./VcnSystemList.vue?vue&type=template&id=70f145e0&scoped=true&"
import script from "./VcnSystemList.vue?vue&type=script&lang=js&"
export * from "./VcnSystemList.vue?vue&type=script&lang=js&"
import style0 from "./VcnSystemList.vue?vue&type=style&index=0&id=70f145e0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70f145e0",
  null
  
)

export default component.exports